export const ENFORCED_THEME_PARAM = "theme";
export const GRAPH_ZOOM_PARAM = "zoom";
export const HIDE_ZOOM_PICKER = "hideZoomPicker";
export const EMBED_QUESTION_TITLE = "embedTitle";
export const CHART_TYPE_PARAM = "chartType";
